var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: "false",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 0.0100098C5.86417 0.0100098 2.5 3.385 2.5 7.53415C2.5 13.7081 9.18333 19.332 9.46833 19.5686L10 20.01L10.5317 19.5686C10.8158 19.332 17.5 13.7081 17.5 7.53415C17.5 3.385 14.1358 0.0100098 10 0.0100098ZM9.99917 17.8054C8.46917 16.385 4.16667 11.9935 4.16667 7.53415C4.16667 4.30713 6.78417 1.68204 10 1.68204C13.2158 1.68204 15.8333 4.30713 15.8333 7.53415C15.8333 11.9843 11.5292 16.3825 9.99917 17.8054ZM7.5 7.53407C7.5 6.1513 8.62167 5.02602 10 5.02602C11.3783 5.02602 12.5 6.1513 12.5 7.53407C12.5 8.91684 11.3783 10.0421 10 10.0421C8.62167 10.0421 7.5 8.91684 7.5 7.53407Z",
    fill: "#DC1928"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.1889647d2493bad8f21d92d9ebeb05dc.svg";
export { ForwardRef as ReactComponent };